"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _carouselImages = _interopRequireDefault(require("../styles/carousel-images.css"));
var _controlsProgressNumbers = _interopRequireDefault(require("./controls-progress-numbers"));
var CarouselControls = function CarouselControls(_ref) {
  var visibleImageIndex = _ref.visibleImageIndex,
    carouselImagesLength = _ref.carouselImagesLength,
    theme = _ref.theme,
    slidesDoubled = _ref.slidesDoubled;
  if (carouselImagesLength > 1) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _carouselImages["default"].controls
    }, /*#__PURE__*/_react["default"].createElement(_controlsProgressNumbers["default"], {
      visibleImageIndex: visibleImageIndex,
      carouselImagesLength: carouselImagesLength,
      theme: theme,
      slidesDoubled: slidesDoubled
    }));
  }
  return '';
};
var _default = CarouselControls;
exports["default"] = _default;